import OfflineOrdersModal from './OfflineOrdersModal';

export default OfflineOrdersModal;
